var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-modal",
    { attrs: { value: "" } },
    [
      _c(
        "w-card",
        { attrs: { "max-width": "500" } },
        [
          _c("w-card-title", [
            _vm._v(_vm._s(_vm.$ct("print-automatic-labels"))),
          ]),
          _c(
            "w-card-content",
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("app-label-layout-select", {
                        attrs: {
                          disabled: _vm.isRunning,
                          "browse-id": 4,
                          fancy: "",
                          label: _vm.$ct("default-layout"),
                        },
                        model: {
                          value: _vm.defaultLayoutId,
                          callback: function ($$v) {
                            _vm.defaultLayoutId = $$v
                          },
                          expression: "defaultLayoutId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("app-stock-location-select", {
                        attrs: {
                          disabled: _vm.isRunning,
                          fancy: "",
                          label: _vm.$ct("to-use-stock-location-for-quantity"),
                        },
                        model: {
                          value: _vm.toUseStockLocationForQuantity,
                          callback: function ($$v) {
                            _vm.toUseStockLocationForQuantity = $$v
                          },
                          expression: "toUseStockLocationForQuantity",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-card-actions",
            [
              _c(
                "w-button",
                {
                  staticClass: "cancel",
                  attrs: { icon: "ban" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
              ),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  attrs: {
                    icon: "check",
                    disabled: !_vm.valid || _vm.isRunning,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.confirm()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }